import { Logger } from '@je-pc/utils'
export default new Logger({
  packageName: '@je-pc/navigation',
  release: '1.1.0'
})
